import { useEffect, useState } from "react";
import App from "./App";
import { useStateContext } from "@xkit-yx/im-kit-ui";
import general, { redux } from "./general";
import useActiveState from "./lib/useActiveState";
import RedEnvelopeAlert from "./view/game/im/chat/redEnvelope/RedEnvelopeAlert";
import Dialog from "./lib/Dialog";

export default function IMAppContainer() {
  const { store, nim } = useStateContext();
  const [allUnreadCount, setAllUnreadCount] = useState(0);
  const [logined, setLogined] = useActiveState("im-logined");
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [pushContent, setPushContent] = useState();

  useEffect(() => {
    redux.dispatch({
      type: "unread",
      data: {
        unread: allUnreadCount,
      },
    });
  }, [allUnreadCount]);

  const handleUnread = () => {
    setAllUnreadCount(store.uiStore.sessionUnread);
  };

  const filterUnreadCount = () => {
    setTimeout(() => {
      handleUnread();
    }, 1000);
  };
  useEffect(() => {
    var nimInstance = nim.getNIM();
    nimInstance.options.oncustomsysmsg = (msg) => {
      console.log("test--------customsysmsg", msg);
      const content = JSON.parse(msg.content);
      console.log("test--------content", content);
      const type = content.type;

      // 批量处理布尔转换
      const boolKeys = ['is_can_snatched', 'is_exists', 'is_pop_bullet', 'is_preview_red'];
      const convertedData = { ...content.data };

      boolKeys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(convertedData, key)) {
          // 处理 '1'/'0', 1/0, 'true'/'false', true/false
          const val = convertedData[key];
          convertedData[key] = (val === '1' || val === 1 || val === 'true' || val === true);
        }
      });
      
      setPushContent({ ...convertedData, type: content.type });
      if (type == "join_cluster_redenvelope") {
        // 社区
        setIndex((e) => e + 1);
      } else if (type == "cluster_task_accomplish") {
        // 群聊
        updateChat(content)
      }
    };

    nim.on("msg", (msg) => {
      setTimeout(() => {
        handleUnread();
      }, 100);
    });
    nim.on("syncdone", (res) => {
      setLogined(true);
      localStorage.setItem("yx_login", true);
      filterUnreadCount();
    });
    nim.on("logined", () => {
      localStorage.setItem("yx_login", true);
      setLogined(true);
    });
  }, []);

  useEffect(() => {
    if (index > 0) {
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    }
  }, [index]);

  const updateChat = (content) =>{
    redux.dispatch({
      type: "refreshActiveRedEnvelope",
      data: {
        refreshRedEnvelopeData: content.data,
      },
    });
  }

  const handleAction = (info) => {
    console.log("info----", info);

    if (info.type == "join_cluster_redenvelope") {
      Dialog.loading();
      general.axios
        .post("/base/yunxin/joinTeams", {
          topic_id: info.maiyou_gameid,
        })
        .finally(() => {
          Dialog.close();
        })
        .then((res) => {
          const { data, status } = res.data;
          if (status.succeed) {
            const { tid } = data.info;
            general.history.push(`/chat?tid=${tid}`);
            // if (localStorage.getItem('yx_login')){
            //   general.history.push(`/chat?tid=${tid}`)
            // }else{
            //   PubSub.publish('loginSubscribe',true)
            //   setTimeout(()=>{
            //     general.history.push(`/chat?tid=${tid}`)
            //   },2000)
            // }
          } else {
            Dialog.error(status.error_desc);
          }
        });
    }
  };

  return (
    <div>
      <App />
      {index > 0 && (
        <RedEnvelopeAlert
          visible={visible}
          type={"join_cluster_redenvelope"}
          getContainer={document.getElementsByClassName("screen-chat-index")[0]}
          attach={pushContent}
          handleAction={handleAction}
        ></RedEnvelopeAlert>
      )}
    </div>
  );
}
